<template>
  <a
    v-if="isExternalLink"
    v-bind="$attrs"
    :href="disabled ? '#' : to"
    :target="disabled ? '_self' : '_blank'"
    :class="{disabled: disabled}"
  >
    <slot />
  </a>

  <router-link
    v-else
    v-slot="{ href, navigate }"
    v-bind="$props"
    custom
  >
    <a
      v-if="disabled"
      v-bind="$attrs"
      :href="href"
      :class="{disabled: disabled}"
    >
      <slot />
    </a>

    <a
      v-else
      v-bind="$attrs"
      :href="href"
      :class="{disabled: disabled}"
      @click="navigate"
    >
      <slot />
    </a>
  </router-link>
</template>

<script setup>
/**
 * This entire component mostly sourced from: https://router.vuejs.org/guide/advanced/extending-router-link.html
 */
import { computed } from 'vue';
import { RouterLink } from 'vue-router';

defineOptions({
  inheritAttrs: false,
});

const props = defineProps({
  ...RouterLink.props,
  disabled: {
    type: Boolean,
    default: false,
  },
});

const isExternalLink = computed(() => {
  return typeof props.to === 'string' && props.to.startsWith('http');
});
</script>
